import styled from "styled-components";

import colors from "../../config/colors.config";

export const SideMenuBtnsStyles = styled.div``;
